import React, { useEffect, useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

// components
import AdminNavbar from 'components/Navbars/AdminNavbar.js'
import Sidebar from 'components/Sidebar/Sidebar.js'
import HeaderStats from 'components/Headers/HeaderStats.js'

// views

import Dashboard from 'views/admin/Dashboard.js'
import Statistics from 'views/admin/Statistics.js'

import CreateUser from 'views/admin/CreateUser'
import CreateStore from 'views/admin/CreateStore'
import EditStore from 'views/admin/EditStore'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import UsersList from 'views/admin/UsersList'
import StoresList from 'views/admin/StoresList'

export default function Admin() {
    const [isAdmin, setIsAdmin] = useState(false)
    const history = useHistory()
    useEffect(() => {
        // Verify token
        const cookie = localStorage.getItem(`robot-token`)
        if (!cookie) {
            history.push('/login')
        }

        const cookieDataItem = localStorage.getItem(`robot-user-data`)
        if (!cookieDataItem) return
        const userData = JSON.parse(cookieDataItem)
        setIsAdmin(userData.role_id === 2)
    }, [])
    return (
        <>
            <Sidebar isAdmin={isAdmin} />
            <div className="relative md:ml-64 bg-blueGray-100">
                <AdminNavbar />

                <HeaderStats />
                <div className="px-4 md:px-10 mx-auto w-full -m-24">
                    <Switch>
                        <Route path="/admin/dashboard" exact component={Dashboard} />
                        <Route path="/admin/statistics" exact component={Statistics} />
                        <Route path="/admin/create-user" exact component={CreateUser} />
                        <Route path="/admin/create-store" exact component={CreateStore} />
                        <Route path="/admin/users" exact component={UsersList} />
                        <Route path="/admin/stores" exact component={StoresList} />
                        <Route path="/admin/edit-store/:id" exact component={EditStore} />
                        <Redirect from="/admin" to="/admin/dashboard" />
                    </Switch>
                    {/* <FooterAdmin /> */}
                </div>
            </div>
        </>
    )
}
